import {  useUserContext } from 'features/users';
import { LoginUserRolePermission, PermissionFlags } from "types";

export const HasPermission = (
  menuKey: string,
  action: keyof PermissionFlags  
): boolean => {
  const { user } = useUserContext();

  if(user===undefined || user?.rolePermission===undefined && Array.isArray(user?.rolePermission))
    return false ;
  
 const rolePermission: LoginUserRolePermission[] = Array.isArray(user?.rolePermission)
  ? user.rolePermission
  : [];

  const item = rolePermission.find(p => p.menuKey === menuKey);
  
return item?.permissions?.[action] ?? false;
};


const basePermissions = [
  { menuKey: "dashboard", permissions: { add: true, delete: true, update: false, view: true, print: true, enable: false } },
  { menuKey: "executive_summary", permissions: { add: true, delete: true, update: false, view: true, print: true, enable: false } },
  { menuKey: "registration", permissions: { add: true, delete: true, update: false, view: true, print: true, enable: false } },
  { menuKey: "shop", permissions: { add: true, delete: true, update: false, view: true, print: true, enable: false } },
  { menuKey: "booth", permissions: { add: true, delete: true, update: false, view: true, print: true, enable: false } },
  { menuKey: "event_management", permissions: { add: true, delete: true, update: false, view: true, print: true, enable: false } },
  { menuKey: "event_list", permissions: { add: true, delete: true, update: false, view: true, print: true, enable: false } },
  { menuKey: "transactions", permissions: { add: false, delete: false, update: false, view: false, print: false, enable: false } },
  { menuKey: "group_registration", permissions: { add: false, delete: false, update: false, view: false, print: false, enable: false } },
  { menuKey: "participant_list", permissions: { add: false, delete: false, update: false, view: false, print: false, enable: false } },
  { menuKey: "reports", permissions: { add: false, delete: false, update: false, view: false, print: false, enable: false } },
  { menuKey: "invoice_list", permissions: { add: false, delete: false, update: false, view: false, print: false, enable: false } },
  { menuKey: "coupon", permissions: { add: true, delete: true, update: false, view: true, print: true, enable: false } },
];
export const getUserPermissions = (user: any) => {
  if (!user) return [];

  // Example: Customize based on user role
  switch (user.role) {
    case "admin":
      return basePermissions.map((p) => ({
        ...p,
        permissions: { ...p.permissions, enable: true }, // admins can enable all
      }));

    case "executive":
      return basePermissions.map((p) => ({
        ...p,
        permissions: { ...p.permissions, add: p.menuKey !== "transactions", update: true }, // executives have restricted access
      }));

    default:
      return basePermissions.map((p) => ({
        ...p,
        permissions: { ...p.permissions }, // default permissions
      }));
  }
};
// export const userPermissions = () => {
//   const { user } = useUserContext();

//   if (!user) return null;

//   const permissions = getUserPermissions(user);
  
// return permissions;
// };
export const useUserPermissions = () => {
  const { user } = useUserContext();

  if (!user) return null;

  return getUserPermissions(user);
};
